import http from '@utils/http';

/**
 * GET /api/v1/project-templates
 */
export const getProjectTemplates = (params = {}) =>
    http.get('/project-templates', { params }).then((res) => {
        const raw = res.data ?? {};
        const list = Array.isArray(raw.data) ? raw.data : Array.isArray(raw) ? raw : [];
        return {
            data: list,
            total: raw.total ?? list.length,
        };
    });

/**
 * GET /api/v1/project-templates/:id
 */
export const getProjectTemplateById = (id) =>
    http.get(`/project-templates/${id}`).then((res) => res.data?.data ?? res.data);

/**
 * POST /api/v1/project-templates
 */
export const createProjectTemplate = (body) =>
    http.post('/project-templates', body).then((res) => res.data?.data ?? res.data);

/**
 * PATCH /api/v1/project-templates/:id
 */
export const updateProjectTemplate = (id, body) =>
    http.patch(`/project-templates/${id}`, body).then((res) => res.data?.data ?? res.data);

/**
 * DELETE /api/v1/project-templates/:id
 */
export const deleteProjectTemplate = (id) =>
    http.delete(`/project-templates/${id}`).then((res) => res.data?.data ?? res.data);
